import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';


export const fetchTinyurlData = createAsyncThunk(
  "influencer/fetchTinyurlData",
  async () => {
    try {
      const response = await axiosInstance.post("/tinyurl/get_tinyurl_list");
      return response.data;
    } catch (error) {
      throw Error(error.message);
    }
  }
);

export const createTinyurl = createAsyncThunk(
  'influencer/createTinyurl',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/tinyurl/create_tinyurl', formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


const initialState = {
    tinyurlData: [],
    createTinyurls: [],
    status: 'idle',
    error: null
};

    // Slice definition
const tinyUrl = createSlice({
  name: 'tinyUrl',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      
        .addCase(fetchTinyurlData.pending, (state) => {
            state.status = "loading";
        })
        .addCase(fetchTinyurlData.fulfilled, (state, action) => {
            state.status = "succeeded";
            state.tinyurlData = action.payload;
        })
        .addCase(fetchTinyurlData.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        })

        .addCase(createTinyurl.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(createTinyurl.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.createTinyurls = action.payload;
        })
        .addCase(createTinyurl.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload ? action.payload.message : action.error.message;
        })

  }
});

export default tinyUrl.reducer;
